import { render, staticRenderFns } from "./DatasetIgnoreList.vue?vue&type=template&id=2842cafa"
import script from "./DatasetIgnoreList.vue?vue&type=script&lang=js"
export * from "./DatasetIgnoreList.vue?vue&type=script&lang=js"
import style0 from "./DatasetIgnoreList.vue?vue&type=style&index=0&id=2842cafa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports